import { TextField } from '@mui/material';
import styled from 'styled-components';

import { SYNMATCH_COLORS } from 'theme';

const PRIMARY_FOCUS_HALO = 'rgba(0, 35, 64, 0.08)';

export const JobsListSection = styled.div`
  padding-block: 4rem 5rem;

  @media (max-width: 48rem) {
    padding-block: 3.25rem 4rem;
  }

  @media (max-width: 30rem) {
    padding-block: 2.5rem 3.25rem;
  }
`;

export const ListHead = styled.header`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const ListEyebrow = styled.p`
  margin: 0;
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.72rem;
  font-weight: 560;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${SYNMATCH_COLORS.text.muted};

  &::before {
    content: '';
    width: 1.6rem;
    height: 0.0625rem;
    background: ${SYNMATCH_COLORS.border.default};
    flex-shrink: 0;
  }
`;

export const ListTitle = styled.h1`
  margin: 0;
  font-size: clamp(2.2rem, 5vw, 3.4rem);
  font-weight: 640;
  letter-spacing: -0.03em;
  line-height: 1.02;
  color: ${SYNMATCH_COLORS.primary};
  overflow-wrap: anywhere;
`;

export const ListCount = styled.p`
  margin: 0;
  font-size: 0.9375rem;
  letter-spacing: -0.008em;
  color: ${SYNMATCH_COLORS.text.muted};
`;

export const CountValue = styled.strong`
  color: ${SYNMATCH_COLORS.text.default};
  font-weight: 560;
  font-variant-numeric: tabular-nums;
`;

export const FilterBar = styled.form`
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr;
  gap: 0.9rem;
  margin-top: 2.5rem;
  padding-block: 1.4rem;
  border-top: 0.0625rem solid ${SYNMATCH_COLORS.border.default};

  @media (max-width: 48rem) {
    grid-template-columns: 1fr;
    gap: 0.875rem;
  }
`;

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const FilterLabel = styled.label`
  font-size: 0.7rem;
  font-weight: 560;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${SYNMATCH_COLORS.text.muted};
`;

export const FilterControl = styled(TextField).attrs({
  fullWidth: true,
  size: 'small',
  variant: 'outlined',
})`
  & .MuiOutlinedInput-root {
    transition: box-shadow 150ms ease;
  }

  & .MuiOutlinedInput-root.Mui-focused {
    box-shadow: 0 0 0 0.1875rem ${PRIMARY_FOCUS_HALO};
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${SYNMATCH_COLORS.primary};
  }
`;

export const StateContainer = styled.div`
  margin-top: 2.5rem;
  border-top: 0.0625rem solid ${SYNMATCH_COLORS.border.default};
  padding-top: 1.5rem;
`;
